import { render, staticRenderFns } from "./UrgentManage.vue?vue&type=template&id=50c90d93&scoped=true&"
import script from "./UrgentManage.vue?vue&type=script&lang=js&"
export * from "./UrgentManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c90d93",
  null
  
)

export default component.exports